<template>
        <v-layout align-center justify-center row fill-height>
            <v-flex
            xs10
            sm5
            >
            <v-card class="elevation-12">
              <v-toolbar
                color="primary"
                dark
                flat
                dense
              >
                <v-toolbar-title>Sign up </v-toolbar-title>
                <v-spacer></v-spacer>               
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    label="E-Mail"
                    :disabled="loading" 
                    name="login"
                    v-model="email"
                    prepend-icon="mdi-account"
                    type="text"
                     hint="Your email will be used to login to the system"
            persistent-hint
                  ></v-text-field>

                  <v-text-field
                  :disabled="loading" 
                    id="password"
                    label="Password"
                    name="password"
                    v-model="password"
                    prepend-icon="mdi-lock"
                                    :append-icon="visible ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="()=>visible = !visible"
                :type="visible ? 'text' : 'password'"

                  ></v-text-field>
                </v-form>
                Already have an account? <router-link to="/login"> login</router-link>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn :disabled="loading" color="primary" @click.stop="register">Register </v-btn>
              </v-card-actions>
            </v-card>
            </v-flex>
    </v-layout>
</template>

<script>
import { mapState, mapActions } from "vuex";
  export default {
    props: {
      source: String,
    },
    data: () => ({
      drawer: null,
      email: "",
      password: "",
      visible: false
    }),
computed: {
    ...mapState({
      loading: state => state.application.loading
    })
  },    
    methods: {
        ...mapActions("application", ["toggleLoading", "setError"]),
        async register(){
            try {
                this.toggleLoading(true);
               let user = await this.$auth.signup(this.email, this.password);
               console.log(user);
             this.toggleLoading(false);
                this.$router.push("/");                
            }catch(e) {
                this.setError(e);                              
            }
        }
    }
  }
</script>